<template>
    <div class="status-type-icon">
        <i :class="[statusClass, statusIcon]"></i>
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        statusType: {
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        statusIcon() {
            if (
                this.statusType == 'high' ||
                this.statusType == 'medium' ||
                this.statusType == 'sanction'
            ) {
                return 'icon-cross-with-circle'
            }
            if (
                this.statusType === false ||
                this.statusType === 'false' ||
                this.statusType == 'low'
            ) {
                return 'icon-tick-with-circle'
            }

            return 'icon-tick-with-circle'
        },
        statusClass() {
            if (this.statusType == 'sanction') {
                return 'black'
            }
            if (this.statusType == 'high') {
                return 'danger'
            }
            if (this.statusType == 'medium') {
                return 'warning'
            }
            if (this.statusType == 'low') {
                return 'low'
            }

            return 'low'
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
